export default "__VITE_ASSET__CH$25NQe__"